import { render, staticRenderFns } from "./ProjectNaPai.vue?vue&type=template&id=b9579f7a&scoped=true&"
import script from "./ProjectNaPai.vue?vue&type=script&lang=js&"
export * from "./ProjectNaPai.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNaPai.vue?vue&type=style&index=0&id=b9579f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9579f7a",
  null
  
)

export default component.exports